<template>

  <div>
    <div style="height: 60px;">
        <el-menu mode="horizontal">
          <el-menu-item class="float_right" index="1">
            <i class="el-icon-phone-outline"></i>
            0531-88881231
          </el-menu-item>
          <el-menu-item @click="login" class="float_right" index="2">登录</el-menu-item>
          <el-menu-item class="float_right men-dc" index="3">
            关于我们
            <ul style="margin-left: -20%;display: none" class="ul-dc">
              <li @click="goCompany" class="dd-c">企业介绍</li>
              <li @click="goAbout" class="dd-c">关于我们</li>
              <li class="dd-c">企业文化</li>
              <li class="dd-c">团队风采</li>
            </ul>
          </el-menu-item>
          <el-menu-item class="float_right" index="4">产品与服务</el-menu-item>
          <el-menu-item @click="navigate" class="float_right" index="5">核心优势</el-menu-item>
          <el-menu-item class="float_right" style="float: right;" index="6">首页</el-menu-item>
          <el-menu-item style="margin-left: 20%;font-size: 22px;color: white" index="7">
            <img style="width: 100%;height: 65px;" :src="require('../static/img/index/LOGO.png')" />
          </el-menu-item>
        </el-menu>
    </div>
    <div class="containerdiv">
      <div style="height: 700px;">
          <el-carousel :interval="4000" height="700px" arrow="always">
            <el-carousel-item>
              <img style="width: 100%" src="../static/img/b1.jpg">
            </el-carousel-item>
            <el-carousel-item>
              <img style="width: 100%" src="../static/img/b2.jpg">
            </el-carousel-item>
            <el-carousel-item>
              <img style="width: 100%" src="../static/img/b3.jpg">
            </el-carousel-item>
            <el-carousel-item>
              <img style="width: 100%" src="../static/img/b4.jpg">
            </el-carousel-item>
          </el-carousel>
      </div>
      <div style="height: 600px;">
          <div style="height: 400px;width: 100%;background-color: aliceblue;border: 1px solid white">
            <center>
              <h2>云解决方案
                <div style="font-size: 18px">
                  依据大数据研发的物联网管控系统，可以为您提供多方协议直连接口
                </div>
              </h2>
              <el-row :gutter="4" style="margin-top: 1%;width: 100%">
                <el-col :span="6">
                  <el-card shadow="never" :body-style="{ padding: '20px',backgroundColor:'aliceblue' }">
                    <img style="width: 100px;height: 100px" src="../static/img/index/head.png" class="image">
                    <div style="padding: 14px;">
                      <span style="font-size: 22px">逻辑控制类</span>
                      <div style="margin-top: 5%">
                        <p class="smallp">状态控制</p>
                        <p class="smallp">用量控制</p>
                        <p class="smallp">自动控制</p>
                        <p class="smallp">速度控制</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="never" :body-style="{ padding: '20px',backgroundColor:'aliceblue' }">
                    <img style="width: 100px;height: 100px" src="../static/img/index/contrl.png" class="image">
                    <div style="padding: 14px;">
                      <span style="font-size: 22px">风控监管类</span>
                      <div style="margin-top: 5%">
                        <p class="smallp">IMEI查询</p>
                        <p class="smallp">终端检测</p>
                        <p class="smallp">地区检索</p>
                        <p class="smallp">风险管控</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="never" :body-style="{ padding: '20px',backgroundColor:'aliceblue' }">
                    <img style="width: 100px;height: 100px" src="../static/img/index/twojie.png" class="image">
                    <div style="padding: 14px;">
                      <span style="font-size: 22px">无缝对接类</span>
                      <div style="margin-top: 5%">
                        <p class="smallp">运营商对接</p>
                        <p class="smallp">三方API对接</p>
                        <p class="smallp">多端对接</p>
                        <p class="smallp">一键式对接</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="never" :body-style="{ padding: '20px',backgroundColor:'aliceblue' }">
                    <img style="width: 100px;height: 100px" src="../static/img/index/ai.png" class="image">
                    <div style="padding: 14px;">
                      <span style="font-size: 22px">智能管理类</span>
                      <div style="margin-top: 5%">
                        <p class="smallp">任务管理</p>
                        <p class="smallp">刷新管理</p>
                        <p class="smallp">知识库</p>
                        <p class="smallp">巡检管理</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </center>
          </div>
      </div>
      <div style="height: 800px;width: 100%">
        <!--核心优势-->
        <div id="hxys" style="width: 100%;height:800px">
          <center>
            <h2>核心优势
              <div style="font-size: 18px">
                综合流行框架夯实基础，结合物联市场为您呈现最优平台
              </div>
            </h2>
            <el-row :gutter="4" style="margin-top: 3%;width: 80%;">
              <a @mouseover="ongn">
                <el-col :span="6">
                  <img style="width: 100px;height: 100px" src="../static/img/index/function.png" class="image">
                  <div>功能板块</div>
                </el-col>
              </a>
              <a @mouseover="onyh">
                <el-col :span="6">
                  <img style="width: 100px;height: 100px" src="../static/img/index/manage.png" class="image">
                  <div>控制板块</div>
                </el-col>
              </a>
              <a @mouseover="onsj">
                <el-col :span="6">
                  <img style="width: 100px;height: 100px" src="../static/img/index/data.png" class="image">
                  <div>数据板块</div>
                </el-col>
              </a>
              <a @mouseover="onkf">
                <el-col :span="6">
                  <img style="width: 100px;height: 100px" src="../static/img/index/openapi.png" class="image">
                  <div>开放板块</div>
                </el-col>
              </a>
            </el-row>
            <div v-show="gn" style="margin-top: 3%;width: 80%;height: 300px;">
              <div style="margin: 30 auto;width: 80%;height: 300PX">
                <img style="width: 700px;height:400px;float: left" src="../static/img/index/echars1.png">
                <ul style="width: 40%;padding-top: 50px;margin-left: 60%;text-align: left">
                  <p style="font-size: 20px">功能模组</p>
                  <li class="c-li">用户可以自定义设置各种规则</li>
                  <li class="c-li">用户可以傻瓜式配置自己的公众平台</li>
                  <li class="c-li">更好的分配各级权限</li>
                  <li class="c-li">可以随时查看操作日志</li>
                </ul>
              </div>
            </div>
            <div v-show="yh" style="margin-top: 3%;width: 80%;height: 150px">
              <div style="margin: 10 auto;width: 80%;height: 100%">
                <img style="height: 45vh;width: 53%;float: left" src="../static/img/index/echars2.png">
                <ul style="width: 40%;padding-top: 50px;margin-left: 60%;text-align: left">
                  <p style="font-size: 20px">控制板块</p>
                  <li class="c-li">实时控制设备的输入输出</li>
                  <li class="c-li">用户可自由查询设备用量详情</li>
                  <li class="c-li">巡检管理设备实时输出</li>
                  <li class="c-li">多线程更新管控设备状态</li>
                </ul>
              </div>
            </div>
            <div v-show="sj" style="margin-top: 3%;width: 80%;height: 150px">
              <div style="margin: 10 auto;width: 80%;height: 100%">
                <img style="height: 45vh;width: 53%;float: left" src="../static/img/index/echars3.png">
                <ul style="width: 40%;padding-top: 50px;margin-left: 60%;text-align: left">
                  <p style="font-size: 20px">数据板块</p>
                  <li class="c-li">大数据监控设备模组</li>
                  <li class="c-li">大数据定位地区位置</li>
                  <li class="c-li">实时分析流水数据</li>
                  <li class="c-li">美观展现数据大屏</li>
                </ul>
              </div>
            </div>
            <div v-show="kf" style="margin-top: 3%;width: 80%;height: 150px">
              <div style="margin: 10 auto;width: 80%;height: 100%">
                <img style="height: 45vh;width: 53%;float: left" src="../static/img/index/echar4.png">
                <ul style="width: 40%;padding-top: 50px;margin-left: 60%;text-align: left">
                  <p style="font-size: 20px">开放板块</p>
                  <li class="c-li">用户可以一键接入运营商API</li>
                  <li class="c-li">用户可开放系统API对接</li>
                  <li class="c-li">随时随地管控设备使用情况</li>
                  <li class="c-li">原地封装API可供用户操作管控</li>
                </ul>
              </div>
            </div>
          </center>
        </div>
      </div>
      <div style="height:600px;">
      <center>
        <h2 style="color: black">案例中心
        </h2>
        <div style="width: 90%;">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="test">
                <img style="width: 100%" src="../static/img/index/an1.jpg" />
              </div>
            </el-col>
            <el-col :span="8">
              <div class="test">
                <img style="width: 100%" src="../static/img/index/an2.jpg" />
              </div>
            </el-col>
            <el-col :span="8">
              <div class="test">
                <img style="width: 100%" src="../static/img/index/an3.jpg" />
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="test">
                <img style="width: 100%" src="../static/img/index/an4.jpg" />
              </div>
            </el-col>
            <el-col :span="8">
              <div class="test">
                <img style="width: 100%" src="../static/img/index/an5.jpg" />
              </div>
            </el-col>
            <el-col :span="8">
              <div class="test">
                <img style="width: 100%" src="../static/img/index/an6.jpg" />
              </div>
            </el-col>
          </el-row>
        </div>
      </center>
    </div>




      <!--资讯中心-->
      <div style="height: 500px;margin-top: 10%">
        <center>
            <h2>资讯中心
              <div style="font-size: 18px">
                结合设计经验与营销实践，反馈最有价值的物联网资讯
              </div>
            </h2>

            <div style="width: 100%;padding: 15px">
              <hr />
              <div>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <p>怎样建立更好的物联网站平台</p>
                    <p style="color: #ef5f33">
                      信息时代、企业或个人为了更好地推销自己的产品或个人最好的方式是建立自己的网站，
                      在常州网站建设上可以是文字、图片、视频等多种方式来介绍和推销自己。
                      今天，我们给大家介绍云智树管理控台！
                    </p>
                  </el-col>
                  <el-col :span="8">
                    <p>app开发须知的流程以及注意事项</p>
                    <p style="color: #ef5f33">
                      app开发中需要考虑到各移动端的兼容性，包括大小屏幕的适配度，文字大小的适配度，
                      弹出数字键盘后的兼容性
                    </p>
                    <p style="color: #ef5f33">
                      app发布前需要告知相关管理平台，获得对应的签名，打包名，牵扯到微信支付的还要
                      在开放平台通过审核，方可发布上线
                    </p>
                  </el-col>
                  <el-col :span="8">
                    <p>如何快速使用云智树控台</p>
                    <p style="color: #ef5f33">
                      登录控台后，在知识库里面可自行查询使用文档，
                      文档中详细介绍该控台的使用方法以及教程
                    </p>
                  </el-col>
                </el-row>
              </div>
          </div>
        </center>
      </div>

      <div style="height: 220px; background-color: #0c2f56;">
        <div style="padding: 30px">
          <el-row :gutter="20">
            <el-col :span="6">
              <p style="color: white; font-size: 20px;">关于我们</p>
              <p style="color: darkgray; font-weight: normal;">企业介绍</p>
              <p style="color: darkgray; font-weight: normal;">咨询中心</p>
              <p style="color: darkgray; font-weight: normal;">联系我们</p>
            </el-col>
            <el-col :span="6">
              <p style="color: white; font-size: 20px;">产品与服务</p>
              <div style="margin-top: 2%;">
                <span style="color: darkgray; font-weight: normal;">管控平台</span>
                <span style="color: darkgray; font-weight: normal; margin-left: 5%;">技术支持</span>
              </div>
              <div style="margin-top: 2%;">
                <span style="color: darkgray; font-weight: normal;">定制功能</span>
                <span style="color: darkgray; font-weight: normal; margin-left: 5%;">售后服务</span>
              </div>
              <p style="color: darkgray; font-weight: normal; margin-top: 2%;">app研发</p>
              <p style="color: darkgray; font-weight: normal; margin-top: 2%;">手机下载</p>
            </el-col>
            <el-col :span="6">
              <p style="color: white;">联系我们</p>
              <p style="color: darkgray; font-weight: normal;">联系电话</p>
              <p style="color: darkgray; font-weight: normal;">QQ咨询</p>
            </el-col>
            <el-col :span="6">
              <img style="width: 150px; height: 150px;" src="../static/img/index/erweima.jpg" />
              <p style="color: white; margin-left: 12%;">微信公众号</p>
            </el-col>
          </el-row>
        </div>

      </div>

    </div>

    <drag/>

  </div>



</template>

<script>
import drag from '../components/levitation_ball.vue'
export default {
  name: 'index',
  components: {
    drag
  },
  data() {
    return {
      gn: true,
      yh: false,
      sj: false,
      kf: false
    }
  },
  methods: {
    handleaudioplay() {},
    login() {
      this.$router.push({
        path: '/account'
      })
    },
    goAbout() {
      this.$nextTick(function () {
        let id = document.getElementById('footer')
        id.scrollIntoView()
      })
    },
    goCompany() {
      this.$router.push({
        path: '/company'
      })
    },
    goWechat() {
      this.$notify({
        title: 'wechat:',
        message: '17753193111',
        position: 'bottom-right'
      })
    },
    goPhone() {
      this.$notify({
        title: '热线电话',
        message: '053188880121',
        position: 'bottom-right'
      })
    },
    goQQQ() {
      location.href = 'tencent://message/?uin=1456183425&Site=qq&Menu=yes'
    },
    goApp() {
      this.$notify({
        title: 'APP下载',
        message: '<div>' + '   <img style="width: 130px;height: 130px" src="https://static-1f8d2829-0dfa-42db-b1c0-8696a99f67f7.bspapp.com/static/app-download/ios.jpg"/>' + '   <img style="width: 130px;height: 130px" src="http://admin.zs2020iot.cn/download/imgs/QR.jpg"/>' + '</div>',
        dangerouslyUseHTMLString: true,
        position: 'bottom-right'
      })
    },
    goTop() {
      this.$nextTick(function () {
        let id = document.getElementById('top')
        id.scrollIntoView()
      })
    },
    navigate() {
      this.$nextTick(function () {
        let id = document.getElementById('hxys')
        id.scrollIntoView()
      })
    },
    reset() {
      this.gn = false
      this.yh = false
      this.sj = false
      this.kf = false
    },
    ongn() {
      this.reset()
      this.gn = true
    },
    onyh() {
      this.reset()
      this.yh = true
    },
    onsj() {
      this.reset()
      this.sj = true
    },
    onkf() {
      this.reset()
      this.kf = true
    }
  }
}
</script>

<style lang="less" scoped>


 .containerdiv {
   height: calc(100vh - 60px);
   overflow-y: auto;
   padding: 0;
   box-sizing: border-box;
   position: relative;
 }

.men-dc:hover .ul-dc {
  display: block !important;
  background-color: white;
  list-style: none;
  line-height: 40px;
  margin-left: 5%;
}
/deep/ .el-card__body:hover {
  background-color: #fbf0ff !important;
}
.talk-c {
  z-index: 999;
  width: 75px;
  height: 440px;
  background: aliceblue;
  right: 0;
  bottom: 10%;
  position: fixed;
}
.btnq:hover {
  border: 1px solid white;
  color: white;
}
.c-li {
  line-height: 45px;
}
.smallp {
  font-weight: normal;
}
.dicc {
  border: 1px solid red;
  width: 1000px; //设置足够的宽度
  margin: 0 auto;
  overflow: hidden;
  white-space: nowrap; //处理块元素中的空白符和换行                                    符的，这个属性保证图片不换行
}

/deep/ .el-main {
  text-align: left;
  /*padding: 20px !important;*/
}

.body {
  height: 100vh;
  overflow: auto;
}

/*.el-carousel__container{
        height: 570px;
    }*/

.logo_Span {
  font-size: 50px;
}

.span_card {
  height: 200px;
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  box-sizing: border-box;
  color: #666666;

  .left {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-around;
    height: 100%;
  }

  .addBold {
    font-weight: bold;
    font-size: 17px;
  }

  .right {
    display: flex;
    align-items: center;
    flex-direction: column;

    justify-content: center;
    flex: 0.5;
    height: 100%;
    color: #ffffff;
    background: #00e2cb;
  }
}

.el-menu--horizontal > .el-menu-item {
  color: #ffffff;
}

/*.el-menu--horizontal > .el-submenu .el-submenu__title {
        color: #ffffff;
    }*/

/** {
        margin: 0px;
        padding: 0px;
    }*/

/*.el-main, .el-header {
        padding: 0px;
    }*/

.float_right {
  float: right !important;
  color: white;
}

.right_herd {
  width: 60%;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/*===================================*/
.drag {
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.handler {
  width: 40px;
  height: 40px;

  border: 1px solid #ccc;
  cursor: move;
}

.handler_bg {
  background: #fff
    url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==')
    no-repeat center;
}

.handler_ok_bg {
  background: #fff
    url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==')
    no-repeat center;
}

.drag_bg {
  background-color: #7ac23c;
  height: 40px;
  width: 0px;
}

.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}

.position-relative {
  position: absolute;
  top: 185px;
  right: 8%;
  z-index: 99;

  .login {
    box-shadow: 0 0 3px 0 rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    min-width: 350px;
    padding: 30px;
    padding-top: 40px;
    background: rgba(10, 57, 113, 0.1);
  }
}

.el-input {
  height: 45px;
  background: transparent;

  input {
    padding-left: 10px;
    background: transparent;
  }
}

/deep/ .el-input__inner {
  height: 100%;
  background: transparent;
  border: 1px solid #3c618e;
  color: #ffffff;
}

/deep/ .el-form-item__content {
  line-height: 45px;
}

/deep/ .el-input__suffix {
  right: 20px;
}

/deep/ .el-menu--horizontal {
  border: none;
  padding: 0 20px;
  background: rgba(12, 47, 86, 2.5);
}
</style>
